module.exports = __webpack_public_path__ + "media/images/placeholders/404-d989d3bdcde84dfd27c8e81264476a9a.svg";